/*
 * @Author: weijinpeng
 * @LastEditors: weijinpeng
 * @Date: 2025-08-07 10:13:42
 * @LastEditTime: 2025-10-16 14:53:06
 * @Description: 
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/style.css'
import voca from "voca";
import "@/util/xdate";
// import locale from '../node_modules/element-ui/lib/locale/lang/en'
import localeEn from '../node_modules/element-ui/lib/locale/lang/en'
import localeZh from '../node_modules/element-ui/lib/locale/lang/zh-CN'
import locale from '../node_modules/element-ui/lib/locale'
import i18n from '@/assets/lang/i18n.js'

Vue.use(ElementUI);

// Element UI 语言切换
// locale.i18n((key, value) => i18n.t(key, value))

// 根据域名切换语言
const hostname = window.location.hostname

// https://netzero.oci-iwt.mvgx.com/
if (hostname.startsWith('cn.')) {
    i18n.locale = 'zh-CN'
    locale.use(localeZh) // ElementUI 跟着切
    localStorage.setItem('lang', 'zh-CN')
} else if (hostname.includes('netzero.mvgx.com') || hostname.includes('netzero.oci-iwt.mvgx.com')) {
    i18n.locale = 'en'
    locale.use(localeEn)
    localStorage.setItem('lang', 'en')
} else {
    i18n.locale = 'zh-CN'
    locale.use(localeZh)
    localStorage.setItem('lang', 'zh-CN')
}

window.v = voca;
Vue.config.productionTip = false

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')